import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Login.vue';
import Layout from './components/Layout.vue';
import Dashboard from './views/Dashboard.vue';
import CustomerList from './views/CustomerList.vue';
import Analysis from './views/Analysis.vue';

import AuthService from '@/services/auth-service';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      component: Layout,
      path: '/',
      meta: {
        private: true,
      },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: '/',
          name: 'customers',
          component: CustomerList,
        },
        {
          path: '/analysis',
          name: 'analysis',
          component: Analysis,
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Home,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const auth = new AuthService();

  if (!(to.name === 'login')) {
    if (auth.token) {
      next();
    } else {
      next('/login');
    }
  } else {
    if (auth.token) {
      next('/');
    }
    next();
  }
});

router.afterEach((transition) => {
  window.scrollTo(0, 0);
});

export default router;
